import { asyncAction } from '../../utils/actions';

export const fetchDeviceAnalytics = asyncAction('admin/FETCH_DEVICE_ANALYTICS');
